        
class ColourInput {

    constructor($compile) {

        var self = this;
        this.$compile = $compile;

        return {
            restrict: 'E',
            templateUrl: 'forms/colour-input.html',
            scope: {
                ngModel: "=",
                adunit: "=",
                onShow: "&?",
                onHide: "&?"
            },
            link: function($scope, $el, $attr) {

                //add label and id
                var $label = $el.find('label');
                if ($attr['label']) $label.text($attr['label']);
                if ($attr['name']) $label.attr('for', $attr['name']);

                let opacity = !!$attr["opacity"];
                let format = $attr["format"];
                let swatches = !!$scope.adunit ? $scope.adunit.colourSwatches : [];
                let $textEl = $("input", $el);

                let options = { 
                    format: format,
                    opacity: opacity,
                    position: "bottom right",
                    theme: "bootstrap",
                    swatches: swatches,
                    letterCase: 'lowercase',
                    defaultValue: '',
                    changeDelay: 200,
                    change: (val, o) => {

                        if(val === "" && "undefined" === typeof $scope.ngModel) {
                            return;
                        }
                        
                        if(val != $scope.ngModel && val.length > 0) {
                            $scope.ngModel = val;
                            $scope.$apply();
                        }

                    },
                    show: () => {

                        if(!!$scope.onShow) {
                            $scope.onShow();
                        }
                        // not widely supported
                        //$(".minicolors-panel". $el)[0].scrollIntoView({block: "end"});
                    },
                    hide: () => {

                        if(!!$scope.onHide) {
                            $scope.onHide();
                        }

                        if(!!$scope.adunit && $scope.adunit.colourSwatches.indexOf($scope.ngModel) < 0) {
                            $scope.adunit.colourSwatches.unshift($scope.ngModel);
                            $scope.$apply();
                        }
                    }
                };

                $scope.$watch("ngModel", () => {
                    if(!!$textEl.data("minicolors-settings")) { // check if element is being torn down
                        if(!$scope.ngModel) {
                            $textEl.minicolors("value", false);
                            $textEl.val("");
                            return;
                        }
                        else if($scope.ngModel !== $textEl.minicolors("value")) {
                            $textEl.minicolors("value", $scope.ngModel);
                        }
                    }
                });

                $scope.$watch("adunit.colourSwatches", (newval) => {
                    if("undefined" !== typeof newval && newval !== null) {
                        options.swatches = newval.filter( (x) => !!x );
                        $textEl.minicolors("settings", options);
                    }
                }, true);

                $textEl.minicolors(options);

            }
        };

    }

    rgb2hex(rgbOrHex) {

        let obj = { color: "", opacity: 1 };
        if(!!rgbOrHex) {
            let rgb = rgbOrHex.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?([.\d]+)[\s+]?/i);
            if(rgb && rgb.length === 5) {
                let color = (rgb && rgb.length === 5) ? "#" +
                    ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
                    ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
                    ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
                obj.color = color;
                obj.opacity = parseFloat(rgb[4],10);
            }
            else if(rgbOrHex.startsWith("#")) {
                obj.color = rgbOrHex;
            }
        }
        return obj;
    }

}


angular.module('cpm')
    .directive('colourInput', () => {
        'use strict';
        return new ColourInput();
    });
